import axios from 'axios'

const TransferService = {
  async get (params = {}) {
    return axios.get('po/inter-branch-transfer/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('po/reports/inter-branch-transfer/request-histories', { params })
  },

  async show (id) {
    return axios.get(`po/inter-branch-transfer/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/inter-branch-transfer/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/inter-branch-transfer/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/inter-branch-transfer/requests/${data.id}`, { data })
  }
}

export default TransferService
